import React, {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {formatErrors} from "../../../constants";
import {clientUpdateAction} from "../../../actions/clientAction";
import {toast} from "react-toastify";
import {InputUserForm} from "../../../utils/input/InputUserForm";

export function ClientRecentDiseases({client, handleChange}) {
  const [edit, setEdit] = useState(false);
  const [form, setForm] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    setForm({
      recent_diseases: client.recent_diseases || '',
      antibiotic: client.antibiotic || ''
    });
  }, [client.recent_diseases, client.antibiotic]);

  const handleChangeForm = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setForm((form) => {
      return {...form, [name]: value}
    });
  };

  const handleCancel = () => {
    if (edit === 'loading') {
      return;
    }
    setForm({
      recent_diseases: client.recent_diseases || '',
      antibiotic: client.antibiotic || ''
    });
    setEdit(false);
  };

  const handleSave = () => {
    if (edit === 'loading') {
      return;
    }
    setEdit('loading');
    dispatch(clientUpdateAction(client.id, form)).then(() => {
      setEdit(false);
      handleChange(form);
    }).catch(err => {
      setEdit(true);
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  return <div className={"tabs__wrapper" + (edit ? " tabs__wrapper--edit" : "")}>
    {!edit && <React.Fragment>
      <span className="tabs__edit edit pointer" onClick={() => setEdit(true)}>Ред.</span>
      <div className="tabs__inner">
        <div className="tabs__heading">Количество ОРВИ и вирусных заболеваний за последний год</div>
        {client.recent_diseases && <div className="tabs__value">{client.recent_diseases}</div>}
        {!client.recent_diseases && <div className="tabs__value">&mdash;</div>}
      </div>
      <div className="tabs__inner">
        <div className="tabs__heading">Прием антибиотиков (6 месяцев)</div>
        {client.antibiotic && <div className="tabs__value">{client.antibiotic}</div>}
        {!client.antibiotic && <div className="tabs__value">&mdash;</div>}
      </div>
    </React.Fragment>}
    {edit && form && <React.Fragment>
      <div className="tabs__inner">
        <div className="tabs__heading">Количество ОРВИ и вирусных заболеваний за последний год</div>
        <div className="tabs__value">
          <InputUserForm type="text" value={form.recent_diseases} name="recent_diseases" disabled={edit === 'loading'} onChange={handleChangeForm}/>
        </div>
      </div>
      <div className="tabs__inner">
        <div className="tabs__heading">Прием антибиотиков (6 месяцев)</div>
        <div className="tabs__value">
          <InputUserForm type="text" value={form.antibiotic} name="antibiotic" disabled={edit === 'loading'} onChange={handleChangeForm}/>
        </div>
      </div>
      <div className="tabs__buttons">
        <span className="tabs__btn tabs__btn--canceling btn pointer" onClick={handleCancel}>Отменить</span>
        <span className="tabs__btn tabs__btn--save btn pointer" onClick={handleSave}>Сохранить</span>
      </div>
    </React.Fragment>}
  </div>;
}
